import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import CustomhtmlForFeature from 'utils/CustomDefault';
import { colorCategories } from '@deck.gl/carto';

export const BROWARDZONINGDISTRICT_LAYER_ID = 'browardZoningDistrictLayer';

const COLORS = [
  [77, 173, 68],
  [210, 41, 9],
  [21, 130, 69],
  [116, 189, 159],
  [0, 81, 45],
  [213, 211, 213],
  [25, 24, 158],
  [122, 102, 168],
  [101, 43, 132],
  [11, 191, 126],
  [254, 247, 105],
  [255, 214, 47],
  [0, 0, 0],
  [49, 90, 199],
];

const LABELS = [
  'Agricultural',
  'Commercial',
  'Community Facilities',
  'Conservation',
  'Government',
  'Industrial',
  'Institutional',
  'Miscellaneous',
  'Mixed-use',
  'Open Space',
  'Residential',
  'Rural',
  'Transportation',
  'Water',
];

const layerConfig = {
  title: 'Zoning Districts',
};

function BrowardZoningDistrictLayer() {
  const dispatch = useDispatch();
  const { browardZoningDistrictLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, browardZoningDistrictLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (browardZoningDistrictLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: BROWARDZONINGDISTRICT_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: browardZoningDistrictLayer.visible,
      opacity: browardZoningDistrictLayer.opacity,
      getFillColor: colorCategories({
        attr: 'Generalized_Zoning_Category',
        domain: LABELS,
        colors: COLORS,
      }),
      pointRadiusMinPixels: 3.5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: BROWARDZONINGDISTRICT_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: CustomhtmlForFeature({
              feature: info.object,
              title: 'Zoning District Details',
              includeColumns: [
                'Municipality',
                'Generalized_Zoning_Category',
                'Zoning_Code',
                'Zoning_Code_Description',
                'Area_Square_Feet',
              ],
            }),
          };
        }
      },
    });
  }
}

export default BrowardZoningDistrictLayer;
